import { Pipe, PipeTransform } from '@angular/core';
import { Jobsite } from '../models';

@Pipe({
  name: 'formatJobsite',
})
export class FormatJobsitePipe implements PipeTransform {
  transform(jobsite: Jobsite): string {
    if (!jobsite) {
      return '-';
    }
    const formated = `${jobsite.name} - ${jobsite.code}`;
    return formated;
  }
}
